import { Button, __css, Text, tokens } from '@fluentui/react-components';

const useStyles = __css({"root":{"mc9l5x":"f22iagw","Beiy3e4":"f1vx9l62","Brf1p80":"f4d9j23","Bt984gj":"f122n59","Bqenvij":"fyg812x","Byoj8tv":0,"uwmqm3":0,"z189sj":0,"z8tnut":0,"B0ocmuz":"fop8ug2","i8kkvl":0,"Belr9w4":0,"rmohyg":"f1ga9sj3"},"title":{"sj55zd":"f1hcrxcs"},"reload":{"B6of3ja":"ffemd8d"}});

export const ErrorPage = ({ message }: { message?: string }) => {
  const styles = useStyles();
  return (
    <div className={styles.root}>
      <Text size={500} weight="semibold" className={styles.title}>
        Something went wrong.
      </Text>
      {message && <Text>{message}</Text>}
      <Button
        className={styles.reload}
        onClick={() => window.location.reload()}
      >
        Reload page
      </Button>
    </div>
  );
};


import "/usr/local/jenkins/workspace/BI_bi-frontend_2.2.3/src/components/ErrorPage.griffel.css";